export const formatPlayerRank = (rank?: number | null): string => {
    return !rank ? "Unranked" : `#${rank}`;
};
